// extracted by mini-css-extract-plugin
module.exports = {"visiiButton":"VisualSearchButton_visiiButton__hEecm","leftToRight":"VisualSearchButton_leftToRight__L8mXm"};